export const traditionalChineseButtonText = {
  "+ Add new folder": "+ 新增資料夾",
  "+ Create Dataset": "+ 建立資料集",
  "+ Create Project": "+ 建立專案",
  "+ Invite new member": "+ 邀請新成員",
  "+ Load More Table": "+ 載入更多資料表",
  ALL: "全部",
  Add: "新增",
  "Add New": "新增",
  Annotate: "標註",
  "Annotate Selected": "標註所選項目",
  "Anomaly Synthesis": "異常合成",
  "API Image Generation": "API 圖片產生",
  "API Keys": "API 金鑰",
  "API keys": "API 金鑰",
  "All Models": "所有模型",
  AUDIO: "音訊",
  "Batch Processing...": "批次處理中...",
  Cancel: "取消",
  Check: "檢查",
  Connect: "連線",
  "Checking...": "檢查中...",
  "Class-Opt": "類別操作",
  "Class-Ops": "類別操作",
  Clear: "清除",
  "Clear Data": "清除資料",
  Clearing: "清除中",
  Clone: "複製",
  "Clone Dataset": "複製資料集",
  "Cloning...": "複製中...",
  Close: "關閉",
  "Compute Iou": "計算 IoU",
  "Compute Uniqueness": "計算唯一性",
  Confirm: "確認",
  Common: "一般",
  Content: "內容",
  "Copy Data Path": "複製資料路徑",
  Create: "建立",
  "Create CVAT Project": "建立 CVAT 專案",
  "Create Dataset": "建立資料集",
  "Creating...": "建立中...",
  Cut: "切割",
  Cutter: "切割",
  "Data Cleansing": "資料清理",
  "Data Generation": "資料產生",
  Datasets: "資料集",
  Delete: "刪除",
  "Delete all": "全部刪除",
  "Delete All": "全部刪除",
  "Delete Bad Label": "刪除不良標籤",
  "Delete folder": "刪除資料夾",
  "Delete one": "刪除一項",
  "Delete Redundancies": "刪除重複項目",
  "Delete Redundant": "刪除重複項目",
  "Delete Samples": "刪除樣本",
  "Delete Selected": "刪除所選項目",
  "Delete dataset": "刪除資料集",
  "Delete settings": "刪除設定",
  Deleting: "刪除中",
  "Deleting...": "刪除中...",
  "Empty Trash": "清空垃圾桶",
  "Emptying...": "清空中...",
  "Deselect All": "取消全選",
  Details: "詳細資料",
  "Down Sample": "降採樣",
  Download: "下載",
  "Download Annotations": "下載標註",
  "Download DAG": "下載 DAG",
  "Download Model Files": "下載模型全部檔案",
  "Packaging...": "打包中...",
  "Download Data": "下載資料",
  "Download NEF": "下載 NEF",
  "Downloading...": "下載中...",
  "Dry run": "試執行",
  "Edit Image": "編輯圖像",
  "Export Label": "匯出標籤",
  "Field-Opt": "欄位操作",
  Fields: "欄位",
  "From Dir": "從目錄",
  Generate: "產生",
  "Generate NEF": "產生 NEF",
  "Go to DAAT": "前往 DAAT",
  Group: "群組",
  IMAGE: "圖像",
  "IP Evaluating...": "IP 評估中...",
  "IP Evaluation": "IP 評估",
  "Import Storage": "匯入儲存空間",
  "Label-Opt": "標籤操作",
  Labels: "標籤",
  Load: "載入",
  "Load Data": "載入資料",
  "Load Label": "載入標籤",
  "Load to Dataset": "載入至資料集",
  "Loading...": "載入中...",
  Local: "本機",
  "Log in": "登入",
  "Make organizer": "設為組織者",
  Members: "成員",
  Merge: "合併",
  "Merge all": "全部合併",
  "Move selected (": "移動所選項目 (",
  "Move to Group": "移至群組",
  Next: "下一頁",
  "Open TensorBoard": "開啟 TensorBoard",
  Pick: "挑選",
  Picker: "挑選",
  Prev: "上一頁",
  Processing: "處理中",
  "Processing...": "處理中...",
  Project: "專案",
  Questions: "問題",
  "Quick ETL": "快速 ETL",
  "Quit organization": "退出組織",
  Refresh: "重新整理",
  "Reassign Dataset": "重新指派資料集",
  Remove: "移除",
  "Remove from Group": "從群組移除",
  "Remove organizer": "移除組織者",
  Rename: "重新命名",
  Reset: "重設",
  "Restore from MinIO": "從 MinIO 還原",
  "Restoring…": "還原中…",
  "Run Anomaly Synthesis": "執行異常合成",
  Sampling: "取樣",
  Save: "儲存",
  "Save API keys": "儲存 API 金鑰",
  "Save defaults": "儲存預設值",
  "Save Parameters": "儲存參數",
  "Saving...": "儲存中...",
  "Saving…": "儲存中…",
  "SDK download Label": "SDK 下載標籤",
  "Select All on Page": "選取本頁全部項目",
  "Select filtered (": "選取篩選結果 (",
  "Send invite": "傳送邀請",
  "Set priority": "設定優先順序",
  "Set Priority": "設定優先順序",
  Submit: "提交",
  "Sign Up": "註冊",
  Skip: "跳過",
  Split: "分割",
  Start: "開始",
  Status: "狀態",
  "System Settings": "系統設定",
  "Tag matched": "標記符合項目",
  TEXT: "文字",
  TABLE: "資料表",
  "Training Defaults": "訓練預設值",
  Untag: "取消標記",
  Upload: "上傳",
  "Upload Data": "上傳資料",
  VIDEO: "影片",
  "View Error": "查看錯誤",
  "View Evaluation": "查看評估",
  "View IP Evaluator": "查看 IP 評估器",
  "Working...": "處理中...",
  "Working…": "處理中…",
  Trash: "垃圾桶",
  ZooModel: "模型庫",
  "auto DAG": "自動 DAG",
  "run id:": "執行 ID：",
};

export const traditionalChineseButtonPatterns = [
  [/^Select filtered \((\d+)\)$/, "選取篩選結果 ($1)"],
  [/^All \((\d+)\)$/, "全部 ($1)"],
  [/^Image \((\d+)\)$/, "圖像 ($1)"],
  [/^Video \((\d+)\)$/, "影片 ($1)"],
  [/^Audio \((\d+)\)$/, "音訊 ($1)"],
  [/^Report \((\d+)\)$/, "報告 ($1)"],
  [/^Text \((\d+)\)$/, "文字 ($1)"],
  [/^Trash \((\d+)\)$/, "垃圾桶 ($1)"],
  [/^Batch ETL \((\d+)\)$/, "批次 ETL ($1)"],
  [/^Move selected \((\d+)\)$/, "移動所選項目 ($1)"],
  [/^Remove (.+)$/, "移除 $1"],
  [/^Clear (.+)$/, "清除 $1"],
  [/^Delete group (.+)$/, "刪除群組 $1"],
  [/^Select (.+)$/, "選取 $1"],
];
